export default "__VITE_ASSET__Bv5Dnf3x__"